<template>
  <div class="msg">

    <el-collapse accordion>
      <el-collapse-item :name="item.id" v-for="(item, i) in list" :key="item.id" @click.native="handleChange(item)" >
        <template slot="title" class="itemTitle">
          <span class="unRead" v-if="item.state === 0"></span>
          <span>{{item.title}}</span>
          <span class="itemTime">{{getChinaTime(item.create_time * 1000)}}</span>
        </template>
        <div>{{item.content}}</div>
      </el-collapse-item>
    </el-collapse>
    <!-- <div class="item_line" v-for="(item, i) in list" :key="item.id">
      <div>

      </div>
    </div> -->

    <div class="pag">
      <Pagination :paginationItem="paginationItem" @changePage="changeCurrentPage" ref="pagination" class="pagination"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Pagination from '@/components/ui/Pagination'
import * as API_USER from '@/api/user'

export default {
  name: 'UserMsg',
  components: {
    Pagination
  },
  data() {
    return {
      paginationItem: {
        page_size: 10,
        pageTotal: 0,
        page_number: 1,
      },
      list: []
    }
  },
  computed: {

  },
  async mounted() {

  },
  created() {
    this.getMsgList()
  },
  methods: {
    getMsgList() {
      API_USER.msgList(this.paginationItem).then(res=> {
        this.paginationItem.pageTotal = res.data.total
        this.list = res.data.rows
      })
    },
    /* 分页currentPage */
    changeCurrentPage(i) {
      this.paginationItem.page_number = i
    },
    handleChange(item) {
      if (item.state === 0 ) {
        let params = {
          id: item.id
        }
        API_USER.editState(params).then(res=> {
          item.state = 1
        })
      }
    },
    getChinaTime(time) {
      return both.getChinaTime(time)
    }
  },
  watch: {
    'paginationItem.page_number'(val, oldVal){
        this.paginationItem.page_number = val
        this.getMsgList()
    }
  }
}
</script>
<style lang="scss" scoped>
.msg{

  .unRead{
    display: inline-block;
    width: 6px;
    height: 6px;
    background: $blue;
    border-radius: 50%;
    margin-right: 10px;
  }

  .itemTime{
    flex: 1;
    padding-right: 20px;
    text-align: right;
  }

  .pag{
    margin-top: 20px;
  }
}
</style>